import { ApiError } from '@anm/api';
import {
  CreateVideoResponse,
  GetManifestResponse,
  HostingElement,
  ReplaceVideoParams,
  UpdateVideoConfigsProps,
  UpdateVideoMetaData,
  UpdateVideoPasswordProps,
  Video
} from '@anm/api/modules/hosting/types';
import { EmbedInfo } from '@anm/api/modules/projects/types';
import { UploadMediaFile } from '@anm/api/modules/uploads';
import { createAction, createAsyncAction } from '@anm/helpers/saga/typesafe-actions';
import { Configs, Password, Poster, VideoSizes } from '@anm/hosting-player';

import {
  // CreateVideoParams,
  // CreateVideoRequest,
  EmbedSizeType,
  EmbedType,
  PopoverEmbed,
  SetVideoData,
  UploadFileParams,
  UploadVideoData,
  UploadVideoProgress
} from './types';

export const getHostedVideoFolders = createAction('wave.video/hosted-video/GET_USER_VIDEO&FOLDERS_DATA')();

export const getHostedVideoFoldersAsync = createAsyncAction(
  'wave.video/hosted-video/GET_USER_VIDEOS&FOLDERS_REQUEST',
  'wave.video/hosted-video/GET_USER_VIDEOS&FOLDERS_SUCCESS',
  'wave.video/hosted-video/GET_USER_VIDEOS&FOLDERS_FAILURE'
)<{}, HostingElement[], ApiError>();

export const deleteVideo = createAction('wave.video/hosted-video/DELETE_VIDEO')<string>();

export const deleteVideoAsync = createAsyncAction(
  'wave.video/hosted-video/DELETE_VIDEO_REQUEST',
  'wave.video/hosted-video/DELETE_VIDEO_SUCCESS',
  'wave.video/hosted-video/DELETE_VIDEO_FAILURE'
)<string, Video, ApiError>();

// export const createVideo = createAction('wave.video/hosted-video/CREATE_VIDEO')<CreateVideoParams>();

// export const cancelUpload = createAction('wave.video/hosted-video/CANCEL_UPLOAD_VIDEO')<string>();

// export const createVideoAsync = createAsyncAction(
//   'wave.video/hosted-video/CREATE_VIDEO_REQUEST',
//   'wave.video/hosted-video/CREATE_VIDEO_SUCCESS',
//   'wave.video/hosted-video/CREATE_VIDEO_FAILURE'
// )<CreateVideoRequest, CreateVideoResponse, ApiError>();

export const uploadVideoProgress = createAction('wave.video/hosted-video/UPLOAD_VIDEO_PROGRESS')<UploadVideoProgress>();

export const uploadVideo = createAction('wave.video/hosted-video/UPLOAD_VIDEO')<UploadVideoData>();

export const uploadVideoAsync = createAsyncAction(
  'wave.video/hosted-video/UPLOAD_VIDEO_REQUEST',
  'wave.video/hosted-video/UPLOAD_VIDEO_SUCCESS',
  'wave.video/hosted-video/UPLOAD_VIDEO_FAILURE'
)<UploadVideoData, {}, ApiError>();

export const getManifest = createAction('wave.video/hosted-video/GET_VIDEO_MANIFEST')<string>();

export const getManifestAsync = createAsyncAction(
  'wave.video/hosted-video/GET_VIDEO_MANIFEST_REQUEST',
  'wave.video/hosted-video/GET_VIDEO_MANIFEST_SUCCESS',
  'wave.video/hosted-video/GET_VIDEO_MANIFEST_FAILURE'
)<string, GetManifestResponse, ApiError>();

export const uploadCustomPoster = createAction('wave.video/hosted-video/UPLOAD_CUSTOM_POSTER')<UploadFileParams>();

export const uploadCustomPosterAsync = createAsyncAction(
  'wave.video/hosted-video/UPLOAD_CUSTOM_POSTER_REQUEST',
  'wave.video/hosted-video/UPLOAD_CUSTOM_POSTER_SUCCESS',
  'wave.video/hosted-video/UPLOAD_CUSTOM_POSTER_FAILURE'
)<UploadFileParams, HostingElement, ApiError>();

export const replaceVideo = createAction('wave.video/hosted-video/REPLACE_VIDEO')<ReplaceVideoParams>();

export const replaceVideoAsync = createAsyncAction(
  'wave.video/hosted-video/REPLACE_VIDEO_REQUEST',
  'wave.video/hosted-video/REPLACE_VIDEO_SUCCESS',
  'wave.video/hosted-video/REPLACE_VIDEO_FAILURE'
)<ReplaceVideoParams, CreateVideoResponse, ApiError>();

export const saveEmbedStatus = createAction('wave.video/hosted-video/SAVE_EMBED_STATUS')<EmbedInfo>();

export const saveEmbedStatusAsync = createAsyncAction(
  'wave.video/hosted-video/SAVE_EMBED_STATUS_REQUEST',
  'wave.video/hosted-video/SAVE_EMBED_STATUS_SUCCESS',
  'wave.video/hosted-video/SAVE_EMBED_STATUS_FAILURE'
)<EmbedInfo, {}, ApiError>();

export const saveVideoConfigs = createAction('wave.video/hosted-video/SAVE_VIDEO_CONFIGS')<UpdateVideoConfigsProps>();

export const saveVideoConfigsAsync = createAsyncAction(
  'wave.video/hosted-video/SAVE_VIDEO_CONFIGS_REQUEST',
  'wave.video/hosted-video/SAVE_VIDEO_CONFIGS_SUCCESS',
  'wave.video/hosted-video/SAVE_VIDEO_CONFIGS_FAILURE'
)<Configs, HostingElement, ApiError>();

export const updateVideoPassword = createAction('wave.video/hosted-video/UPDATE_VIDEO_PASSWORD')<
  UpdateVideoPasswordProps
>();

export const saveVideoPassword = createAction('wave.video/hosted-video/SAVE_VIDEO_PASSWORD')<
  UpdateVideoPasswordProps
>();

export const saveVideoPasswordAsync = createAsyncAction(
  'wave.video/hosted-video/SAVE_VIDEO_PASSWORD_REQUEST',
  'wave.video/hosted-video/SAVE_VIDEO_PASSWORD_SUCCESS',
  'wave.video/hosted-video/SAVE_VIDEO_PASSWORD_FAILURE'
)<Password, HostingElement, ApiError>();

export const clearCreatedVideo = createAction('wave.video/hosted-video/CLEAR_CREATED_VIDEO')();

export const createFileError = createAction('wave.video/hosted-video/CREATE_FILE_ERROR')<ApiError>();

export const saveVideoMeta = createAction('wave.video/hosted-video/SAVE_VIDEO_META')<UpdateVideoMetaData>();

export const saveVideoMetaAsync = createAsyncAction(
  'wave.video/hosted-video/SAVE_VIDEO_META_REQUEST',
  'wave.video/hosted-video/SAVE_VIDEO_META_SUCCESS',
  'wave.video/hosted-video/SAVE_VIDEO_META_FAILURE'
)<void, void, ApiError>();

export const setVideoData = createAction('wave.video/hosted-video/SET_VIDEO_DATA')<SetVideoData>();

export const clearVideoData = createAction('wave.video/hosted-video/CLEAR_VIDEO_DATA')();

export const updateConfigs = createAction('wave.video/hosted-video/UPDATE_CONFIGS')<Configs>();

export const updatePlayerColor = createAction('wave.video/hosted-video/UPDATE_PLAYER_COLOR')<string>();

export const updatePoster = createAction('wave.video/hosted-video/UPDATE_POSTER')<Poster>();

export const discardConfigsChanges = createAction('wave.video/hosted-video/DISCARD_CONFIGS_CHANGES')();

export const discardPosterChanges = createAction('wave.video/hosted-video/DISCARD_POSTER_CHANGES')();

export const discardPlayerColorChanges = createAction('wave.video/hosted-video/DISCARD_PLAYER_COLOR_CHANGES')();

export const discardPasswordChanges = createAction('wave.video/hosted-video/DISCARD_RASSWORD_CHANGES')();

export const toggleEmbedStatus = createAction('wave.video/hosted-video/TOGGLE_EMBED_STATUS')<boolean>();

export const cleanHostedVideoStore = createAction('wave.video/hosted-video/CLEAN_HOSTED_VIDEO_STORE')();

export const checkUpload = createAction('wave.video/hosted-video/CHECK_UPLOAD')<string>();

export const checkUploadAsync = createAsyncAction(
  'wave.video/hosted-video/CHECK_UPLOAD_REQUEST',
  'wave.video/hosted-video/CHECK_UPLOAD_SUCCESS',
  'wave.video/hosted-video/CHECK_UPLOAD_FAILURE'
)<string, UploadMediaFile, ApiError>();

export const changeEmbedType = createAction('wave.video/hosted-video/CHANGE_EMBED_TYPE')<EmbedType>();

export const updateEmbedSizes = createAction('wave.video/hosted-video/UPDATE_EMBED_SIZES')<VideoSizes>();

export const updateEmbedSizeType = createAction('wave.video/hosted-video/UPDATE_EMBED_SIZE_TYPE')<EmbedSizeType>();

export const updatePopoverEmbed = createAction('wave.video/hosted-video/UPDATE_POPOVER_EMBED')<Partial<PopoverEmbed>>();

export const triggerPosterStatus = createAction('wave.video/hosted-video/TRIGGER_POSTER_STATUS')();

export const toggleNotifications = createAction('wave.video/hosted-video/TOGGLE_NOTIFICATIONS')<boolean>();
